const angleDown = {
  prefix: 'fas',
  iconName: 'angle-down',
  icon: [389, 512, [], '', 'M18.93 147.3a37.3 37.3 0 0 1 52.75 0L194.5 270.12 317.33 147.3a37.3 37.3 0 1 1 52.75 52.75L194.5 375.62 18.93 200.06a37.3 37.3 0 0 1 0-52.75Z']
};
const spinner = {
  prefix: 'fas',
  iconName: 'spinner',
  icon: [24, 24, [], '', 'M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z']
};

export { angleDown as a, spinner as s };
//# sourceMappingURL=localIcons-t7qtQAY6-D_8tzsxC.js.map
